var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "has-text-centered" }, [
    _c(
      "div",
      { staticClass: "modal-container has-background-white has-text-centered" },
      [
        _c("div", {
          staticClass:
            "delete is-pulled-right right10 is-large has-background-grey-light",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        }),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { ref: "dDiv", attrs: { id: "qrDiv" } },
          [
            _c("qrcode-vue", {
              staticClass: "is-inline-block marginAutod",
              attrs: {
                id: "qr",
                value: _vm.toPrint,
                size: _vm.size,
                level: "H"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "top5 has-text-dark font36" }, [
              _vm._v("slink.com/"),
              _c("b", [_vm._v(_vm._s(_vm.slink))])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.showMsg
          ? _c("div", { staticClass: "is-size-6 has-text-turk" }, [
              _vm._v("Please use a computer to download QR code.")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-turk top15",
            attrs: {
              id: "dnButt",
              download: "download.png",
              disabled: _vm.showMsg
            },
            on: { click: _vm.dnld }
          },
          [_vm._v("DOWNLOAD")]
        ),
        _vm._v(" "),
        _c("br")
      ]
    ),
    _vm._v(" "),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e27c88e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e27c88e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalQR.vue
// module id = null
// module chunks = 